import { ProjectDuplicateStatusGq } from './../models/ProjectDuplicateStatusGq';
import { QueryHookOptions } from '@apollo/client';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import gql from 'graphql-tag';

export function useGetProjectStatusGq(
  command: CommandGq,
  options?: QueryHookOptions<DataGq, Variables>
) {
  const query = useCustomQuery<DataGq, Variables>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network',
    ...options,
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getProjectStatus,
  };
}

const gqTag = gql`
  query GetProjectStatus($command: GetProjectStatusCommand!) {
    projects {
      getProjectStatus(command: $command) {
        totalCount
        googleAdsProcessingCount
        serpProcessingCount
        serpCompletedCount
        translatingCount
        taggedCount
        loading
        keywordSearchLoading
        longtailLoading
        longtailCount
        rankingsLoading
        automaticDomainsLoading
        domainRankCalculationsLoading
        scrapingUrls
        autoTagging
        generatingKeywordDownload
        generatingAnalysisDownload
        transferringSerpToTracking
        tagGenerationStep
        duplicateStatus
        duplicateLlmRequestCount
        includedRanksQueued
        includedTagsQueued
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getProjectStatus: GetProjectStatusResultGq;
  };
}

export interface GetProjectStatusResultGq {
  readonly totalCount: number;
  readonly googleAdsProcessingCount: number;
  readonly serpProcessingCount: number;
  readonly serpCompletedCount: number;
  readonly translatingCount: number;
  readonly taggedCount: number;
  readonly loading: boolean;
  readonly keywordSearchLoading: boolean;
  readonly longtailLoading: boolean;
  readonly longtailCount: boolean;
  readonly rankingsLoading: boolean;
  readonly automaticDomainsLoading: boolean;
  readonly domainRankCalculationsLoading: boolean;
  readonly scrapingUrls: boolean;
  readonly autoTagging: boolean;
  readonly generatingKeywordDownload: boolean;
  readonly generatingAnalysisDownload: boolean;
  readonly transferringSerpToTracking: boolean;
  readonly tagGenerationStep?: string;
  readonly duplicateStatus: ProjectDuplicateStatusGq;
  readonly duplicateLlmRequestCount: number;
  readonly includedRanksQueued: boolean;
  readonly includedTagsQueued: boolean;
}

export interface Variables {
  command: CommandGq;
}
export interface CommandGq {
  projectId: number;
}
